import React from "react";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/WinnerCRUDConfig.json";
import PageHeader from "../../components/PageHeader";
import { Box } from "@mui/material";

function WinnerPage() {
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          flexGrow: 1,
          marginTop: 0,
          marginLeft: 15,
          marginRight: 15,
          marginBottom: 15,
        }}
      >
        <PageHeader pageTitle="Manage Your Winner" />
        <CrudManager
          data={schema}
          createRequired={false}
          actionBtnName="Add New winner"
          createFormTitle="Add Winner"
          updateFormTitle="Update Winner"
        />
      </Box>
    </Box>
  );
}

export default WinnerPage;
